import { useParams } from "react-router-dom";
import { TaskListForm } from "./TaskListForm";

interface TaskListSettingsProps {
  listId?: string;
}

export function TaskListSettings({ listId: propListId }: TaskListSettingsProps = {}) {
  const { listId: paramListId } = useParams<{ listId: string }>();
  const listId = propListId || paramListId;
  return <TaskListForm mode="edit" listId={listId} />;
}